<template>
  <div class="registration-by-invitation-code">
    <b-container fluid class="user-login ">
      <div class="my-5">
        <b-row align-h="center" align-v="center">
          <b-col sm="12">
            <b-card no-body class="max_width_400 w-100 m-auto v2_box_teal">
              <b-card-header
                class="user-login__card-header v2_font_size_18 v2_color_black v2_box_teal_header"
              >
                Register for Phairify
              </b-card-header>
              <b-card-body class="user-login__card-body pt-3">
                <form @submit.prevent="validateToken">
                  <b-form-group label="Enter your invitation code">
                    <b-form-input
                      type="text"
                      v-model.trim="$v.token.$model"
                      class="p-3 phairify-border-grey height_auto v2_font_size_18 v2_color_black form-control"
                      placeholder="Invitation Code"
                      :state="validateState('token')"
                    />
                    <div
                      v-show="$v.token.$anyError"
                      tabindex="-1"
                      role="alert"
                      aria-live="assertive"
                      aria-atomic="true"
                      class="invalid-feedback"
                    >
                      {{ tokenInvalidFeedback }}
                    </div>
                  </b-form-group>
                  <b-alert :show="!!message" variant="danger">
                    <span v-html="message" />
                  </b-alert>
                  <b-col cols="12" class="text-center">
                    <b-button
                      variant="v2_primary"
                      type="submit"
                      :disabled="loading"
                    >
                      <b-spinner v-if="loading" small />
                      <span v-else>Register</span>
                    </b-button>
                  </b-col>
                </form>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, helpers } from 'vuelidate/lib/validators';
import Api from '@/providers/Api';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import validateStateMixin from '@/mixins/validateStateMixin';

const lengthEqual = (length) => (value) =>
  !!value && helpers.len(value) === length;

export default {
  name: 'AuthRegistrationUsingInvitationCode',
  mixins: [validationMixin, validateStateMixin],
  data: function () {
    return {
      token: null,
      loading: false,
      message: null,
    };
  },
  validations: {
    token: {
      required,
      lengthEqual: lengthEqual(32),
    },
  },
  computed: {
    tokenInvalidFeedback: function () {
      return !this.$v.token.lengthEqual
        ? 'Registration Code length must be 32 characters'
        : 'This field is required';
    },
  },
  methods: {
    validateToken: async function () {
      this.$v.$touch();

      if (this.$v.$anyError) {
        return;
      }

      this.loading = true;
      this.message = null;
      try {
        const response = await Api.validateToken(this.token);
        if (response) {
          this.$router.push(`/registration/${this.token}`);
        }
      } catch (e) {
        if (e.response.status === 404 || e.response.status === 400) {
          this.message = e.response.data.message;
        } else {
          handleServerErrorWithValidation(e, this.$toasted);
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped />
